<template>
	<div class="hea">
		<div class="header">
			<p>欢迎来到采购中心</p>
			<ul>
				<!-- <li class="logings" v-else>
					<p>欢迎您，<router-link to="/ttshop_user" v-text="user.nickname"></router-link> <strong @click="signout()">退出</strong></p>
				</li> -->
				<li class="logings" v-if="admin == 0 ">
					<p>欢迎您,<strong @click="signout1()">退出</strong></p>
				</li>
				<li class="logings" v-else-if="admin == 1">
					<p>欢迎您,<strong @click="signout()">退出</strong></p>
				</li>
				<!-- v-if="enterpriseName" -->
				<!-- v-text="enterprise_name" -->
				<!-- v-else -->
				<li class="logings" v-else>
					<p>欢迎您,<strong @click="sigon()">未登录</strong></p>
				</li>
				<li v-if="admin == 0 && !admin " @click="myorder">我的订单<img src="../../../assets/purchase/image/header/xiala.png"></li>
				<!-- <li @click="personal">个人中心<img src="../../../assets/purchase/image/header/xiala.png"></li> -->
				<li  v-if="admin == 0 && !admin" @click="mycart"><img src="../../../assets/purchase/image/header/cart.png">购物车</li>
			</ul>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				route_url: this.$route.params.route_url,
				// enterprise_name: this.$store.state.qycg_user.name,
				enterpriseName:456,
				admin: this.$store.state.qycg_user.is_admin,
			}
		},
		// created() {
			
		// },
		mounted(){
			// console.log(this.$store.state.qycg_user.name,"enterpriseName")
			// console.log(this.admin,"admin")
		},
		methods:{
			myorder(){
				this.$router.push(this.common.qycgrouter(this) + "/ordercenter");
			},
			personal(){
				this.$router.push(this.common.qycgrouter(this) + "/personal");
			},
			mycart(){
				this.$router.push(this.common.qycgrouter(this) + "/qycgcart");
			},
			signout(){
				window.localStorage.removeItem('qycgUserInfo');
				this.$store.commit("qycgUserInfo", '');
				this.$router.replace(this.common.qycgrouter(this)+"/qycglogin");
				this.$store.commit("routeUrl", '');
				this.$store.commit("qycgTitle", '');
			},
			signout1(){
				window.localStorage.removeItem('qycgUserInfo');
				this.$store.commit("qycgUserInfo", '');
				window.location.reload()
				// this.$router.replace(this.common.qycgrouter(this)+"/qycgindex");
				this.$store.commit("routeUrl", '');
				this.$store.commit("qycgTitle", '');
			},
			// 未登录，去登录
			sigon(){
				this.$router.push(this.common.qycgrouter(this) + "/qycglogin");
			},

		}
	}
</script>

<style lang="scss" scoped>
	.hea{
		width: 100%;
		height: 32px;
		background: #F5F5F5;
		.header{
			width: 1080px;
			margin: 0 auto;
			display: flex;
			justify-content: space-between;
			p{
				height: 32px;
				font-size: 12px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #666666;
				line-height: 32px;
			}
			ul{
				display: flex;
				height: 32px;
				align-items: center;
				li{
					float: left;
					margin-left: 20px;
					display: flex;
					align-items: center;
					cursor: pointer;
				}
				.logings {
					p {
						font-size: 12px;
						color: #999;
				
						span {
							font-size: 12px;
							color: #ff0e25;
							cursor: pointer;
						}
				
						strong {
							margin-left: 2px;
							font-size: 12px;
							color: #999;
							font-weight: 500;
							transition: 0.5s;
							-moz-transition: 0.5s;
							-webkit-transition: 0.5s;
							-o-transition: 0.5s;
							cursor: pointer;
				
							&:hover {
								color: #ff0e25;
							}
						}
					}
				}
			}
			img{
				width: 12px;
				height: 12px;
			}
		}
	}
</style>
